export const TabItem = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
